import { createSlice, PayloadAction } from '@reduxjs/toolkit'  
// types and utils
import { IAuthState, ResetSuccessEnum } from 'features/auth/types'
// services

const initialState = {
  user: null,
  profile: null,
  currentTenant: '',
  currentCustomer: '',
  eobEnabled: false,
  ascEnabled: false,
  eobFaxNumber: '',
  eobDeliveryWindow: '',
  authChallenge: {
    challengeName: null,
    challengeParam: null,
  },
  logoutTime: '0',
  hasUpdatedLoginDetails: false,
  loading: {
    login: false,
    updateProfile: false,
  },
  error: {
    login: false,
    updateProfile: false,
  },
  success: {
    updateProfile: false,
  },
} as IAuthState

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateAuthChallenge: (state, action: PayloadAction<{ [k: string]: any }>) => {
      state.authChallenge = { ...state.authChallenge, ...action.payload }
    },
    updateAuthCurrentTenant: (state, action: PayloadAction<string>) => {
      state.currentTenant = action.payload
    },
    updateAuthCurrentCustomer: (state, action: PayloadAction<string>) => {
      state.currentCustomer = action.payload
    },
    setAuthSession: (state, action) => {
      const { currentUser } = action.payload
      state.user = currentUser
    },
    logout: (state) => {
      state.user = null
      state.hasUpdatedLoginDetails = false
    },
    resetSuccess: (state, action: PayloadAction<ResetSuccessEnum>) => {
      if (state.success[action.payload]) state.success[action.payload] = false
    },
    updateLocalStateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload }
    },
    setAuthUser: (state, action) => {
      state.user = action.payload
    },
    eobEnabled: (state, action) => {
      state.eobEnabled = action.payload
    },
    ascEnabled: (state, action: PayloadAction<boolean>) => {
      state.ascEnabled = action.payload
    },
    eobFaxNumber: (state, action) => {
      state.eobFaxNumber = action.payload
    },
    eobDeliveryWindow: (state, action) => {
      state.eobDeliveryWindow = action.payload
    },
    logoutTime(state, action) {
      state.logoutTime = action.payload
    },
    setLoginDetailsUpdated: (state, action: PayloadAction<boolean>) => {
      state.hasUpdatedLoginDetails = action.payload
    },
  },
})

export const {
  setAuthUser,
  setAuthSession,
  logout,
  resetSuccess,
  updateAuthCurrentTenant,
  updateAuthCurrentCustomer,
  updateLocalStateUser,
  updateAuthChallenge,
  eobEnabled,
  ascEnabled,
  eobFaxNumber,
  eobDeliveryWindow,
  logoutTime,
  setLoginDetailsUpdated,
} = authSlice.actions

export const authReducer = authSlice.reducer
